import React, { PureComponent, Fragment } from 'react';
import List from '@material-ui/core/List';
import styled from 'styled-components';
import { Box } from '@solvhealth/jigsaw-v1';
import ProfileListRow from './ProfileListRow';
import ProfileDeletionDialog from './ProfileDeletionDialog';
import AccountViews from '../../AccountGetsMarried/constants/AccountViews';
import { ACCOUNT_HOME_PATH } from '../../../constants/index';
import { ACCOUNT_HOME_VIEW } from '../../Account/util/views';
import { navigateToView } from '../../Account/util/views';
import { colors } from '../../../constants/colors';
import { analyticsTrackEvent } from '../../../core/analytics';
import { Actions, Events } from '../../Account/util/analytics';
import { getProfileColorTheme } from '../../Account/util/colors';
import { AccountSummary } from '~/reducers/account';

const Profiles = styled(List).withConfig({ componentId: 'sc-ecgmpt-0' })`
  background: ${colors.theWhiteAlbum};
  padding-bottom: 0;
`;

const Item = styled.div.withConfig({ componentId: 'sc-ecgmpt-1' })`
  margin: 0;
  padding: 0;
  margin-left: 5px;

  :last-child {
    border-bottom: none;
  }
`;

const profileRegex = new RegExp(
  `${AccountViews.Manage}|${AccountViews.Insurance}|${AccountViews.Profile}|${AccountViews.GetCare}`
);

type OwnProps = {
  accountSummary?: AccountSummary;
  currentProfile?: any;
  deleteUserProfile?: (...args: any[]) => any;
  badgeList?: any[];
  isInEditMode?: boolean;
  onSelect?: (...args: any[]) => any;
};

type State = any;

type Props = OwnProps & typeof ProfileList.defaultProps;

class ProfileList extends PureComponent<Props, State> {
  static defaultProps = {
    accountSummary: { user_profiles: [] },
    currentProfile: {},
  };

  state = {
    deleteOpen: false,
    userProfileToDelete: null,
    edit: false,
  };

  getProfileCount = (accountSummary: any) => {
    const profiles = this.getProfiles(accountSummary);
    return profiles && profiles.length;
  };

  getProfiles = (accountSummary: any) =>
    accountSummary &&
    accountSummary.user_profiles &&
    accountSummary.user_profiles.filter((p: any) => p.is_verified);

  handleListItemClick = (e: any, userProfile: any) => {
    if (this.props.isInEditMode) {
      return this.handleDeleteOpen(userProfile);
    }

    const { accountSummary } = this.props;
    analyticsTrackEvent(Events.ACCOUNT_NAVIGATION, {
      action: Actions.PROFILE_SELECTOR,
      label: 'Touch Profile',
      numberOfProfiles: this.getProfileCount(accountSummary),
    });

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onSelect(userProfile);
    let view = ACCOUNT_HOME_VIEW;
    if (window.location.pathname.includes(ACCOUNT_HOME_PATH)) {
      const match = window.location.pathname.match(profileRegex);
      if (match) [view] = match;
    }

    return navigateToView(view, userProfile.user_profile_id);
  };

  handleDeleteOk = (e: any) => {
    e && e.stopPropagation();
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.deleteUserProfile(this.state.userProfileToDelete.user_profile_id);
    this.setState({ userProfileToDelete: null, deleteOpen: false });
  };

  handleDeleteCancel = (e: any) => {
    e && e.stopPropagation();
    this.setState({ deleteOpen: false });
  };

  handleDeleteOpen = (userProfile: any) => {
    this.setState({ userProfileToDelete: userProfile, deleteOpen: true });
  };

  render = () => {
    const { accountSummary, isInEditMode, badgeList } = this.props;

    const profiles = this.getProfiles(accountSummary);

    return (
      <>
        <Profiles>
          {profiles &&
            profiles.map((p: any, i: any) => (
              <Fragment key={p.user_profile_id}>
                <Item onClick={(e) => this.handleListItemClick(e, p)}>
                  <ProfileListRow
                    isBadged={badgeList?.includes(p.user_profile_id)}
                    isVerified={p.is_verified}
                    openDeleteProfile={this.handleDeleteOpen}
                    profileColor={getProfileColorTheme(accountSummary, p.user_profile_id).primary}
                    relationshipToAccount={p.relationship_to_account}
                    showPlusLogo={accountSummary?.is_active_membership}
                    showRightArrow={!isInEditMode}
                    showTrashCan={isInEditMode}
                    userProfile={p}
                  />
                </Item>

                <Box border="solid 1px" borderColor="gray-100" marginLeft={3} />
              </Fragment>
            ))}
        </Profiles>

        <ProfileDeletionDialog
          handleProfileDeletion={this.handleDeleteOk}
          onClose={this.handleDeleteCancel}
          open={this.state.deleteOpen}
          userProfile={this.state.userProfileToDelete}
        />
      </>
    );
  };
}

export default ProfileList;
